import { render } from "./LoginPage.vue?vue&type=template&id=28bfe788&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=28bfe788&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bfe788"]])

export default __exports__